import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {ProjectAreaName} from "../projects/Project";

/**
 * Represents a module for managing project teams and their associations with specific privileges.
 *
 * @typedef {Object} Module
 * @property {string} identifier
 *   The unique identifier for the module, representing the scope "project_teams".
 * @property {function} isPrivileged
 *   A function to check whether a given user has a specific privilege within the context of
 *   the project teams module.
 */
export const TeamModule: Module = {
    identifier: "project_teams",
    isPrivileged: ( authUser, privilege) =>
        isPrivileged( authUser, ProjectAreaName, TeamModule.identifier, privilege  )
};